import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthService } from 'src/app/auth/auth.service';
import { mayStartImpersonation, UserRole } from '../../models/user.model';
import { DashboardService } from '../../services/dashboard.service';
import { selectCompanyData } from '../../stores/company/company.selector';
import { selectProfileData } from '../../stores/profile/profile.selector';

@Component({
  selector: 'app-dashboard-tabs',
  templateUrl: './dashboard-tabs.component.html',
  styleUrls: ['./dashboard-tabs.component.scss'],
  standalone: false,
})
export class DashboardTabsComponent {
  company$ = this.store.select(selectCompanyData);
  responseBanner$ = this.dashboardService.dashboardResponseBanner$;

  constructor(
    protected router: Router,
    private store: Store,
    private dashboardService: DashboardService,
    private authService: AuthService,
  ) {}

  profile$ = this.store.select(selectProfileData);
  protected readonly UserRole = UserRole;
  protected readonly mayStartImpersonation = mayStartImpersonation;

  logoutProfile() {
    this.authService.logout();
  }
}
